export default {
  'log.title': '订单推送日志',
  'log.title.ms': '管理Shopline订单推送Sendcloud日志',
  'log.tab.all': '全部',
  'log.tab.success': '成功',
  'log.tab.fail': '失败',
  'log.tab.push.today': '今日推送',
  'log.tab.to.Sync': '同步',
  'log.table.title.webHookName': '类型',
  'log.table.title.OrderNO': '编号',
  'log.table.title.createAt': '时间',
  'log.table.title.requestStatus': '状态',
  'log.table.title.message': '消息',
  'log.table.title.action': '操作'
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/dashboard/log.js